import {apiV2} from './api';
import CardsProfile from 'records/CardsProfile';
import {List} from 'immutable';

// Iit would be nice if the the urls were consistent with the property
// ('cards' vs 'scorecards') but alas they are not consistent in the api
export default {
  fetch(id) {
    return apiV2
      .getJson(`/admin/scorecards/profile/${id}`)
      .then(profile => new CardsProfile(profile));
  },
  fetchAll() {
    return apiV2
      .getJson('/admin/scorecards/profiles')
      .then(({profiles}) => List(profiles.map(profile => new CardsProfile(profile))));
  },
  create(profile, shouldOverwrite) {
    return apiV2
      .postJson(`/admin/scorecards/profile`, profile.toJS(), {
        params: {overwrite: shouldOverwrite},
      })
      .then(profile => new CardsProfile(profile));
  },
  update(profile, shouldOverwrite) {
    return apiV2
      .putJson(`/admin/scorecards/profile/${profile.id}`, profile.toJS(), {
        params: {overwrite: shouldOverwrite},
      })
      .then(profile => new CardsProfile(profile));
  },
};
